// Importaciones de React, librerías de animación, enrutamiento y recursos.
import React from 'react';
import { motion } from 'framer-motion'; // Para animaciones declarativas.
import { Link } from 'react-router-dom'; // Para la navegación interna.
import { useInView } from 'react-intersection-observer'; // Para detectar la visibilidad de elementos.
import empresaImage from '../img/basadaa.png';
import facebook from '../img/facebook.png';
import whatsapp from '../img/whatsapp.png';

/**
 * Componente Informacion.
 * Muestra la información de contacto de la empresa en un diseño de dos columnas,
 * con una imagen a la izquierda y los detalles de contacto a la derecha.
 */
const Informacion = () => {
    // Hook para detectar cuando el contenedor de la derecha entra en el viewport.
    const [ref, inView] = useInView({
        triggerOnce: true, // La animación solo se dispara una vez.
        threshold: 0.5,    // Se activa cuando el 50% del elemento es visible.
    });

    // Define las variantes de animación para el contenedor de la derecha.
    const containerVariants = {
        visible: { opacity: 1, y: 0 }, // Estado final: visible y en su posición original.
        hidden: { opacity: 0, y: 50 }, // Estado inicial: invisible y desplazado 50px hacia abajo.
    };

    return (
        // Contenedor principal con layout flexible que cambia de columna a fila en pantallas grandes.
        <div className="container mx-auto flex flex-col lg:flex-row justify-center items-center p-8 fondo">
            
            {/* Columna izquierda: Imagen de fondo. */}
            <div 
                className="w-full lg:w-[50%] lg:h-[600px] h-[100px] mb-10 lg:mb-0 lg:mt-20 flex justify-center items-center pr-8 bg-cover bg-center md:mr-12 rounded"
                style={{backgroundImage: `url(${empresaImage})`}}
            >
             </div>

            {/* Columna derecha: Contenedor de la información de contacto con animación. */}
            <motion.div
                ref={ref} // Asigna la referencia para la detección de visibilidad.
                initial="hidden" // Estado inicial de la animación.
                animate={inView ? "visible" : "hidden"} // Activa la animación cuando `inView` es true.
                variants={containerVariants} // Usa las variantes definidas.
                transition={{ duration: 0.6, delay: 0.2 }} // Configuración de la transición.
                className="relative w-full lg:w-[50%] flex flex-col justify-center items-center lg:items-start text-white"
            >
                
                {/* Caja 1: Información de Contacto. */}
                <motion.div
                    className="p-8 rounded-lg shadow-md mb-4 w-full lg:w-[80%] bg-[#0e0f52]"
                    variants={containerVariants} // Reutiliza las variantes para una animación consistente.
                >
                    <h2 className="text-3xl font-bold mb-4">Información de Contacto</h2>
                    <p className="mb-2 text-2xl"><strong>Horario de Atención:</strong> Lunes a Viernes, 9am - 5pm</p>
                </motion.div>

                {/* Caja 2: Contacto y redes sociales. */}
                <motion.div
                    className="bg-[#0e0f52] p-8 rounded-lg shadow-md w-full lg:w-[80%] relative"
                    variants={containerVariants}
                >
                    <h2 className="text-3xl font-bold mb-4">Contacto</h2>
                    <p className="mb-2 text-2xl"><strong>Teléfono:</strong> +52 221 522 8483</p>
                    <p className="mb-4 text-2xl "><strong>Correo Electrónico:</strong> gestion@dscyber.io</p>
                    
                    {/* Iconos de redes sociales con animación al pasar el cursor. */}
                    <div className="flex justify-center lg:absolute lg:bottom-0 lg:right-0 mb-4 mr-4">
                        <a href="https://wa.me/522215228483" target="_blank" rel="noopener noreferrer">
                            <motion.img
                                src={whatsapp}
                                alt="Whatsapp"
                                className="w-8 h-8"
                                whileHover={{ scale: 1.2 }} // Anima la escala al hacer hover.
                            />
                        </a>
                        <a href="https://www.facebook.com/dscyber.io/" target="_blank" rel="noopener noreferrer" className="ml-4">
                            <motion.img
                                src={facebook}
                                alt="Facebook"
                                className="w-8 h-8"
                                whileHover={{ scale: 1.2 }}
                            />
                        </a>
                    </div>
                    
                    {/* Botón que enlaza a la página de consultas. */}
                    <Link to="/consultas" className="bg-blue-500 text-white py-2 px-4 rounded-md border-transparent hover:bg-blue-600 transition-colors duration-300">Consultar</Link>
                </motion.div>
            </motion.div>
        </div>
    );
};

// Exporta el componente.
export default Informacion;
